import React from 'react';

import CardPerson from '@elements/CardPerson';

import './style.css';

type PersonProps = {
  contentful_id: string,
  title: string,
}

type PeopleListProps = {
  item: {
    contentful_id: string,
    title: string,
    subtitle: string,
    showTitle: string,
    people: PersonProps[],
  },
};

const PeopleList = ({
  item: {
    people,
    title,
    subtitle,
    showTitle,
  }
}: PeopleListProps): JSX.Element => (
  <div className="people-list--main">
    {
      showTitle && (
        <>
          <hr className="people-list__line" />
          <h2 className="people-list__title">
            {title}
          </h2>
        </>
      )
    }
    {
      showTitle && (
        <p className="people-list__subtitle">
          {subtitle}
        </p>
      )
    }
    <section className="people-list__container">
      {
        people?.map( person => (
          <CardPerson
            key={person?.contentful_id}
            person={person}
          />
        ))
      }
    </section>
  </div>
);

export default PeopleList;
